import React from "react";
import "../styles/RegistrationFee.css";

const RegistrationFee = () => {
  const registrationData = [
    {
      category: "Student / Research Scholars",
      indian: "₹ 7000 + 18% GST",
      foreign: "$250 USD",
    },
    { category: "Faculty", indian: "₹ 8000 + 18% GST", foreign: "$300 USD" },
    { category: "Industry", indian: "₹ 9000 + 18% GST", foreign: "$300 USD" },
    { category: "Attendees", indian: "₹ 2000 + 18% GST", foreign: "$150 USD" },
  ];

  return (
    <section id="registration" className="registration-fee">
      <div className="container">
        <h2 className="section-title">Paper Submission Fee</h2>
        <p className="section-subtitle">
          Transparent and Competitive Pricing for All Participants
        </p>
        <div className="registration-table-wrapper">
          <table className="registration-table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Indian Participants</th>
                <th>Foreign Participants</th>
              </tr>
            </thead>
            <tbody>
              {registrationData.map((item, index) => (
                <tr key={index}>
                  <td className="category-cell">{item.category}</td>
                  <td className="price-cell">{item.indian}</td>
                  <td className="price-cell">{item.foreign}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="registration-cta">
          <h3>Final Paper Registration</h3>
          <p>Register your accepted paper for presentation at ICETTACS 2026.</p>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLScotsNUU_uN9pp0t5YN8W47hMGiKJw0DyzsviUnoKEB8b-_DA/viewform?usp=sharing&ouid=108519411571228248070" target="_blank" rel="noopener noreferrer">
            <button className="btn btn-primary">Register Now</button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default RegistrationFee;
